import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-MQM19PLMTJ"); // your Measurement ID
};

export const trackPageView = (path) => {
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
};